import { render, staticRenderFns } from "./referee.vue?vue&type=template&id=7bef2ffa&"
import script from "./referee.vue?vue&type=script&lang=js&"
export * from "./referee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports